import { useEffect, useRef } from "react";
import ReportViewer from "../../../../../../../../components/ReportViewer";
import useSelectedPatient, {
  PatientProfile,
} from "../../../../../../../../hooks/local-storage/use-selected-patient";
import { useGetProviderGroupProfile } from "../../../../../../../../queries/admin/provider-group/use-get-provider-group-profile";
import { useGetPrescriptionById } from "../../../../../../../../queries/patient-chart/order/prescription/use-get-prescription-by-Id";
import { getXtenantId } from "../../../../../../../../utils/utils";
import PrescriptionPrint from "./PrescriptionPrint";

const PrintPrescription = ({
  prescriptionFormId,
  onClose,
}: {
  prescriptionFormId?: string;
  onClose?: () => void;
}) => {
  if (!prescriptionFormId) return;

  const pdfRef = useRef<{ generatePdf: () => void }>(null);
  const [patientData] = useSelectedPatient();
  const { data, isLoading, isFetching, isPending, isRefetching } =
    useGetPrescriptionById({
      prescriptionFormId,
      xTENANTID: getXtenantId(),
    });

  const prescriptionData = data?.data;

  useEffect(() => {
    if (prescriptionData) {
      setTimeout(() => {
        pdfRef.current?.generatePdf();
      }, 1000);
    }
  }, [prescriptionData]);

  // todo : provider group API should remove when we store locally data
  const { data: providerGroupProfileData }: any = useGetProviderGroupProfile(
    getXtenantId() ?? undefined,
    false
  );

  return (
    <ReportViewer
      pdfRef={pdfRef}
      loading={isLoading || isFetching || isPending || isRefetching}
      onClose={() => {
        onClose?.();
      }}
      title="Prescription Report"
    >
      {prescriptionData && (
        <PrescriptionPrint
          formData={prescriptionData}
          providerGroupProfileData={providerGroupProfileData}
          patientData={patientData as PatientProfile}
        />
      )}
    </ReportViewer>
  );
};

export default PrintPrescription;
